import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DateInput } from "@/components/DateInput";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";

const SECTIONS = [
  ["Identificação", "Nome que os clientes veem e dados legais da empresa.", [
    ["nome_comercial", "Nome comercial", "", 2], ["firma", "Firma (denominação social)", "", 2], ["nipc", "NIPC", "9 dígitos"],
    ["ami", "N.º da licença AMI *", "Obrigatório · só números"], ["cae", "CAE / CIRS"]]],
  ["Sede e contactos", "Usados no Anexo B (entidade comunicante) e no Casa Pronta (requerente).", [
    ["morada", "Morada / sede social", "", 2], ["codigo_postal", "Código postal"], ["localidade", "Localidade"], ["pais", "País", "Portugal"],
    ["telefone", "Telefone"], ["email", "Email geral da agência", "", 2], ["site", "Site", "ex.: www.agencia.pt", 2],
    ["privacy_email", "Email de privacidade (aviso do portal do cliente)", "ex.: privacidade@agencia.pt", 2]]],
  ["Seguro de responsabilidade civil", "Obrigatório para a mediação imobiliária.", [["seguradora", "Seguradora"], ["apolice", "N.º da apólice"]]],
  ["Comissão por defeito", "Proposta em cada nova angariação e no contrato de mediação.", [
    ["comissao_pct", "Comissão (%)", "ex.: 5", 1, "number"], ["divisao_consultor_pct", "Parte do consultor (%)", "ex.: 50", 1, "number"]]],
  ["Declarante do Anexo B (IMPIC)", "Pessoa responsável pelo preenchimento. Se o nome ficar vazio, usa-se quem gera o documento.", [
    ["declarante_qualidade", "Qualidade"], ["declarante_nome", "Nome"], ["declarante_nif", "NIF"], ["declarante_doc_tipo", "Documento (CC, Passaporte…)"],
    ["declarante_doc_num", "N.º do documento"], ["declarante_doc_validade", "Validade do documento", "", 1, "date"]]],
];

function Split({ v }) {
  const n = Number(v);
  if (v === "" || v == null || Number.isNaN(n)) return null;
  return <p className="text-xs text-slate-500 sm:col-span-2" data-testid="agency-split-preview">Consultor {n}% · Agência {Math.max(0, 100 - n)}%</p>;
}

export function AgenciaDefinicoes() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/agency/settings").then(({ data }) => setF(data)); }, []);
  if (!f) return <div className={card}>A carregar…</div>;
  const save = async () => {
    const num = (v) => (v === "" || v == null ? null : Number(v));
    try {
      const { data } = await api.put("/agency/settings", { ...f, comissao_pct: num(f.comissao_pct), divisao_consultor_pct: num(f.divisao_consultor_pct) });
      setF(data); toast.success("Dados da agência guardados");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const setCp = async (v) => {
    const cp = v.replace(/[^\d-]/g, "").slice(0, 8);
    setF((x) => ({ ...x, codigo_postal: cp }));
    if (/^\d{4}-\d{3}$/.test(cp)) {
      try { const { data } = await api.get(`/postal/${cp}`); if (data.city) { setF((x) => ({ ...x, localidade: data.city })); } } catch { /* sem geoapi: fica como escrito */ }
    }
  };
  const field = ([k, label, ph, span, type]) => (
    <div key={k} className={span === 2 ? "sm:col-span-2" : ""}>
      <Label htmlFor={`ag-${k}`}>{label}</Label>
      {type === "date"
        ? <DateInput value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`agency-${k}`} />
        : <Input id={`ag-${k}`} type={type || "text"} value={f[k] ?? ""} placeholder={ph || ""} className="mt-1.5" data-testid={`agency-${k}`}
            onChange={(e) => (k === "codigo_postal" ? setCp(e.target.value) : setF({ ...f, [k]: e.target.value }))} />}
    </div>
  );
  return (
    <div className="space-y-6 max-w-3xl" data-testid="agency-settings">
      {SECTIONS.map(([title, desc, fields]) => (
        <div key={title} className={card}>
          <h3 className="font-heading text-lg text-ec-green">{title}</h3>
          <p className="text-sm text-slate-500 mb-5">{desc}</p>
          <div className="grid sm:grid-cols-2 gap-4">
            {fields.map(field)}
            {title === "Comissão por defeito" && <Split v={f.divisao_consultor_pct} />}
          </div>
        </div>
      ))}
      <button onClick={save} className="bg-ec-green text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-ec-greenDark transition-colors" data-testid="agency-save">Guardar dados da agência</button>
    </div>
  );
}
